import { ReactComponent as cable_label } from "./cable_label.svg"
import { ReactComponent as cable_ties } from "./cable_ties.svg"
import { ReactComponent as ceiling_mount } from "./ceiling_mount.svg"
import { ReactComponent as custom_holes } from "./custom_holes.svg"
import { ReactComponent as eyelets } from "./eyelets.svg"
import { ReactComponent as flag_mount } from "./flag_mount.svg"
import { ReactComponent as hanging } from "./hanging.svg"
import { ReactComponent as keyring } from "./keyring.svg"
import { ReactComponent as magnet } from "./magnet.svg"
import { ReactComponent as magnet_rug } from "./magnet_rug.svg"
import { ReactComponent as military } from "./military.svg"
import { ReactComponent as needle } from "./needle.svg"
import { ReactComponent as none } from "./none.svg"
import { ReactComponent as pole, ReactComponent as pole_flanged } from "./pole.svg"
import { ReactComponent as s_hook } from "./s_hook.svg"
import { ReactComponent as screw } from "./screw.svg"
import { ReactComponent as screw_capped } from "./screw_capped.svg"
import { ReactComponent as self_adhesive } from "./self_adhesive.svg"
import { ReactComponent as self_adhesive_floor } from "./self_adhesive_floor.svg"
import { ReactComponent as self_adhesive_pad } from "./self_adhesive_pad.svg"
import { ReactComponent as stand } from "./stand.svg"
import { ReactComponent as suction_cups } from "./suction_cups.svg"
import { ReactComponent as table_stand } from "./table_stand.svg"
import { ReactComponent as tape } from "./tape.svg"
import { ReactComponent as tape_and_screw } from "./tape_and_screw.svg"
import { ReactComponent as wall_distance } from "./wall_distance.svg"
import { ReactComponent as wall_profile } from "./wall_profile.svg"

const icons: IconMap = {
  eyelets,
  flag_mount,
  hanging,
  magnet_rug,
  magnet,
  none,
  screw,
  self_adhesive,
  self_adhesive_floor,
  suction_cups,
  table_stand,
  tape_and_screw,
  tape,
  self_adhesive_pad,
  wall_profile,
  wall_distance,
  pole,
  pole_flanged,
  needle,
  military,
  stand,
  screw_capped,
  ceiling_mount,
  s_hook,
  keyring,
  cable_label,
  cable_ties,
  custom_holes,
}

export default icons
